import Store from './Store';

const DeliveryOrderStore = new Store('deliveries');

export {
    DeliveryOrderStore
};